export default "__VITE_ASSET__BbDFt5z4__"